import { Colors, Typography } from '../../../theme';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
const Styles = labelStyles('FormLabelRequiredText', {
    root: Object.assign(Object.assign({}, Typography.smallPrint1), { color: Colors.neutral700, textTransform: 'lowercase', '&::before': {
            content: '"("',
        }, '&::after': {
            content: '")"',
        }, '&[data-state="disabled"]': {
            color: Colors.neutral500,
        } }),
});
export const FormLabelRequiredText = ({ children = 'Required', isDisabled = false, }) => {
    return (isolateComponent("span", { "aria-hidden": "true", css: Styles.root, "data-state": isDisabled ? 'disabled' : undefined }, children));
};
//# sourceMappingURL=FormLabelRequiredText.js.map
// @zapier/design-system@6.28.0 (14d5b99c8)
